"use strict";

var _interopRequireDefault = require("/www/wwwroot/check/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _defineProperty2 = _interopRequireDefault(require("/www/wwwroot/check/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _request = _interopRequireDefault(require("@/utils/request"));
var _fileImage = _interopRequireDefault(require("@/components/fileImage.vue"));
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _vuex = require("vuex");
var _user = require("@/api/user");
var _formatMixin = require("@/utils/formatMixin");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports.default = {
  components: {
    FileImage: _fileImage.default,
    Pagination: _index.default
  },
  mixins: [_formatMixin.formatMixin],
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['name', 'perms'])), {}, {
    // isAdmin
    // 如果perms包含 admin 字段 即为管理员，则返回true  否则为false
    isAdmin: function isAdmin() {
      return this.perms.includes('admin');
    }
  }),
  data: function data() {
    return {
      document: {},
      attachments: [],
      listLoading: false,
      orderList: {
        count: 0
      },
      moneyList: {
        count: 0
      },
      // 充值余额流水
      listQuery: {
        page: 1,
        page_size: 10
      },
      // 修改余额form
      accoutform: {
        sumcharge: '',
        recharge: 0 // 充值余额
      },
      // 余额提现form
      accoutform1: {
        sumcharge: '',
        withdrawal: 0 //提现余额
      },
      dialogVisibleAccount: false,
      //控制修改余额form
      dialogVisibleAccount1: false,
      //控制余额提现form
      dialogVisibleshop: false,
      // 控制修改商家信息form
      // 保存从服务器获取的修改收费form数据,开关数据也在里面，用于展示
      chargeform: {
        score_pano_money: 0,
        unify_money: 0,
        pay_risk_behavior_money: 0,
        report_money: 0,
        //报表数据单笔生成费用
        bear_money: 0,
        //风控单笔调用费用 
        key: '',
        // 
        key_secret: '',
        court_detail_pro_money: 0,
        zhengxin_money: 0,
        apply_loan_c_money: 0,
        financial_blacklist_money: 0,
        fengkong_default_money: 0,
        gz_money: 0
      },
      moneyform: {
        score_pano_money: 0,
        bear_money: 0,
        report_money: 0,
        pay_risk_behavior_money: 0,
        unify_money: 0,
        court_detail_pro_money: 0,
        zhengxin_money: 0,
        apply_loan_c_money: 0,
        financial_blacklist_money: 0,
        fengkong_default_money: 0,
        gz_money: 0
      },
      dialogVisibleCharge: false,
      //控制修改收费form,
      dialogVisibleChargeTwo: false,
      //控制修改返点form,
      dialogVisibleChargeThree: false,
      dialogVisibleChargeFour: false,
      dialogVisibleChargeFive: false,
      dialogVisibleChargeSix: false,
      dialogVisibleChargeSeven: false,
      dialogVisibleChargeEight: false,
      dialogVisibleChargeNine: false,
      dialogVisibleChargeTen: false,
      dialogVisibleChargeBlack: false,
      // 以下为商家收费配置3个开关的值
      value1: true,
      value2: true,
      value3: true,
      // 收集修改收费form数据，提交给后端

      // 商家基础信息
      shopInfo: {},
      // 修改商家基础信息form
      shopform: {
        company_name: '',
        real_name: '',
        scc: '',
        card_code: '',
        mobile: '',
        orgStr: '',
        orgKey: '',
        orgId: ''
      },
      isRequesting: false,
      // 控制按钮是否禁用的标志位
      lastExecutedTime: 0 // 上次执行的时间
    };
  },
  created: function created() {
    this.pk = this.$route.query.id;
    // 获取商家数据
    this.getList();
    this.getList1();
    // 获取充值余额流水
    this.getMoneyList();
    // 获取商家收费配置数据
    this.getCharge();
  },
  methods: {
    // 获取商家信息数据——done
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _request.default)({
        url: "/Shop/".concat(this.pk, "/"),
        method: 'get'
      }).then(function (response) {
        if (response.data) {
          _this.document = response.data;
          // this.shopform = response.data
          // 获取商家余额
          //   this.accoutform.sumcharge = response.data.user.real_money
          //   this.accoutform1.sumcharge = response.data.use.real_money
          //   this.getMoney()
        }
        _this.listLoading = false;
      });
      // 获取商家照片
      (0, _request.default)({
        url: "/ShopFile/",
        method: 'get',
        params: {
          'shop': this.pk
        }
      }).then(function (response) {
        if (response.data) {
          _this.attachments = response.data.results;
        }
      });
    },
    // 获取商家信息数据——新接口
    getList1: function getList1() {
      var _this2 = this;
      this.listLoading = true;
      (0, _request.default)({
        url: "/system/shopConfig/getInfoAll/",
        method: 'get',
        params: {
          shop_id: this.pk
        }
      }).then(function (res) {
        _this2.shopInfo = res.data;
        _this2.shopform.company_name = res.data.company_name;
        _this2.shopform.real_name = res.data.real_name;
        _this2.shopform.scc = res.data.scc;
        _this2.shopform.card_code = res.data.card_code;
        _this2.shopform.orgStr = res.data.orgStr;
        _this2.shopform.orgKey = res.data.orgKey;
        _this2.shopform.orgId = res.data.orgId;
        _this2.shopform.mobile = res.data.mobile;
        _this2.listLoading = false;
      }).catch(function (err) {
        console.log(err);
      });
    },
    handleFilter: function handleFilter() {
      this.getList();
    },
    // 页头--返回上级页面——done
    goBack: function goBack() {
      this.$router.go(-1);
    },
    // 获取商家余额——done
    // 获取余额流水——done
    getMoneyList: function getMoneyList() {
      var _this3 = this;
      this.listLoading = true;
      // 王工封装
      // type 1为充值余额流水  type 2 为支付宝账号流水
      (0, _request.default)({
        url: "/system/shopConfig/getUserRecord/",
        method: 'put',
        data: {
          shop_id: this.pk,
          //   type: 1,
          page: this.listQuery.page,
          page_size: this.listQuery.page_size,
          is_pay: 1
        }
      }).then(function (response) {
        if (response.data) {
          _this3.moneyList = response.data.data;
          _this3.accoutform.sumcharge = response.data.data.user_money;
          _this3.accoutform1.sumcharge = response.data.data.user_money;
        }
        _this3.listLoading = false;
      });
    },
    // 修改余额保存，加限制——done
    onSubmitAccount: function onSubmitAccount() {
      var _this4 = this;
      var currentTime = Date.now();
      if (currentTime - this.lastExecutedTime > 2000) {
        if (this.accoutform.recharge < 1) {
          this.$message.error('最少1豆');
          return;
        }
        this.isRequesting = true; // 禁用按钮
        console.log(this.$user);
        // 发请求提交数据给后端
        (0, _request.default)({
          url: "/system/user/money/",
          method: 'put',
          data: {
            shop_id: this.pk,
            money: this.accoutform.recharge
          }
        }).then(function (response) {
          if (response.code == 200) {
            _this4.dialogVisibleAccount = false;
            _this4.accoutform.recharge = 0;
            _this4.getList(); //重新获取数据
            // this.getList1()
            _this4.getMoneyList(); // 重新获取充值余额流水
            _this4.isRequesting = false; // 启用按钮
            _this4.lastExecutedTime = currentTime;
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        this.$message.error('请勿频繁操作');
        this.lastExecutedTime = currentTime;
      }
    },
    // 余额提现保存，加限制——done
    onSubmitAccount1: function onSubmitAccount1() {
      var _this5 = this;
      var currentTime = Date.now();
      if (currentTime - this.lastExecutedTime > 2000) {
        if (this.accoutform1.withdrawal < 1) {
          this.$message.error('最少1豆');
          return;
        }
        this.isRequesting = true; // 禁用按钮
        // 发请求提交数据给后端
        (0, _request.default)({
          url: "/system/user/moneyDec/",
          method: 'put',
          data: {
            customer: this.document.customer,
            money: this.accoutform1.withdrawal
          }
        }).then(function (response) {
          if (response.code == 200) {
            _this5.dialogVisibleAccount1 = false;
            _this5.accoutform.withdrawal = 0;
            _this5.getList(); //重新获取数据
            _this5.getMoneyList(); // 重新获取充值余额流水
            _this5.isRequesting = false; // 启用按钮
            _this5.lastExecutedTime = currentTime;
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        this.$message.error('请勿频繁操作');
        this.lastExecutedTime = currentTime;
      }
    },
    // 获取商家收费配置数据——done
    getCharge: function getCharge() {
      var _this6 = this;
      (0, _request.default)({
        url: "/system/shopConfig/getConfig/",
        method: 'get',
        params: {
          // shop_id: this.$user.data.shop,
          shop_id: this.pk
        }
      }).then(function (response) {
        if (response.data) {
          _this6.chargeform = response.data;
          _this6.moneyform.bear_money = response.data.bear_money;
          _this6.moneyform.report_money = response.data.report_money;
          _this6.moneyform.pay_risk_behavior_money = response.data.pay_risk_behavior_money;
          _this6.moneyform.unify_money = response.data.unify_money;
          _this6.moneyform.score_pano_money = response.data.score_pano_money;
          _this6.moneyform.court_detail_pro_money = response.data.court_detail_pro_money;
          _this6.moneyform.zhengxin_money = response.data.zhengxin_money;
          _this6.moneyform.apply_loan_c_money = response.data.apply_loan_c_money;
          _this6.moneyform.financial_blacklist_money = response.data.financial_blacklist_money || 0;
          _this6.moneyform.fengkong_default_money = response.data.fengkong_default_money;
          _this6.moneyform.gz_money = response.data.gz_money;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    // 修改收费保存——done
    onSubmitChargeTwo: function onSubmitChargeTwo() {
      var _this7 = this;
      (0, _request.default)({
        url: "/system/shopConfig/updateConfigTwo/",
        method: 'put',
        data: {
          shop_id: this.pk,
          field: 'value',
          value: JSON.stringify(this.moneyform)
        }
      }).then(function (response) {
        if (response.code == 200) {
          _this7.dialogVisibleChargeTen = false;
          _this7.dialogVisibleChargeEight = false;
          _this7.dialogVisibleChargeNine = false;
          _this7.dialogVisibleChargeSeven = false;
          _this7.dialogVisibleChargeSix = false;
          _this7.dialogVisibleChargeFour = false;
          _this7.dialogVisibleChargeThree = false;
          _this7.dialogVisibleChargeTwo = false;
          _this7.dialogVisibleCharge = false;
          _this7.dialogVisibleChargeFive = false;
          _this7.getCharge(); //重新获取数据
        }
      }).catch(function (error) {
        console.log(error);
      });

      // 提交数据给后端
    },
    // 修改商家信息保存——done
    onSubmitShop: function onSubmitShop() {
      var _this8 = this;
      // 提交数据给后端
      (0, _request.default)({
        url: "/system/shopConfig/updateInfo/",
        method: 'put',
        data: {
          shop_id: this.pk,
          company_name: this.shopform.company_name,
          real_name: this.shopform.real_name,
          scc: this.shopform.scc,
          card_code: this.shopform.card_code,
          mobile: this.shopform.mobile,
          orgStr: this.shopform.orgStr,
          orgId: this.shopform.orgId,
          orgKey: this.shopform.orgKey
        }
      }).then(function (response) {
        if (response.code == 200) {
          _this8.dialogVisibleshop = false;
          _this8.getList1(); //重新获取商家数据
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    goToGz: function goToGz() {
      var url = 'https://risk.jiujiuqian.cn/gzdzshqsh.docx';
      // console.log(url)
      window.open(url, '_blank');
    }
  }
};